module.exports = __webpack_public_path__ + "img/index8.24b600cd.png";